import React, {useState} from 'react';
import '../css/Login.css';
import axios from 'axios';
import {TextField} from '@mui/material';
const Addkse = () => {

    const [formData, setFormData] = useState({
        program: '',
        section: '',
        occassion : '',
        year : '',
      });
    
      const [message, setMessage] = useState('');
      //const navigate = useNavigate();
    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
      };
    
      const handleSubmit = async (e) => {
        e.preventDefault();
       console.log('submit clicked');
        try {
          const res = await axios.post('/api/programs', formData);
          console.log('formData', formData);
          //setMessage(res.data.message);
          if (res.status === 200 || res.status === 201) {
            
            // Redirect to dashboard
            //navigate('/dashboard');
              const user = res.data.newUser; // 👈 This is where user.email comes from
           console.log('user', user);
         
            
            //setMessage(`${formData.role.toUpperCase()} Program created successfully!`);
            alert("Program added successfully");
       
          }
        } catch (error) {
          console.log(error);
          if (error.res?.data?.error) {
            setMessage(error.res.data.error);
          } else {
            setMessage("Something went wrong");
          }
        }
      };
 
    return (
        
  <div className="login-container">
     
        

        <form className="login-form" onSubmit={handleSubmit}>
            <h2>Add a Program</h2>
          <TextField
            type="text"
            name="program"
            placeholder="Program Name"
            onChange={handleChange}
            required
            //className="w-full px-4 py-2 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-purple-400"
          />
          <TextField
            type="text"
            name="section"
            placeholder="Eg. Upper Primary"
            onChange={handleChange}
            required
            //className="w-full px-4 py-2 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-purple-400"
          />
          <TextField
            type="text"
            name="occassion"
            placeholder="Occassion"
            onChange={handleChange}
            required
            //className="w-full px-4 py-2 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-purple-400"
          />
            <TextField
            type="text"
            name="year"
            placeholder="year"
            onChange={handleChange}
            required
            //className="w-full px-4 py-2 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-purple-400"
          /> 
          
         
          <button
            type="submit"
            onClick={(e) => handleSubmit(e)}
          >
            Upload
          </button>
         
        </form>

        
      </div>
   


    )
};

export default Addkse;